import * as PIXI from "pixi.js";

/* 
WHAT: Create default tiled background texture
WHY: Tiled background sprite functions as a "grid" 
*/
export function drawBG(gridWidth, gridHeight) {

    const texture = PIXI.Texture.from('./blocks/polished_andesite.png');
    
    const tilingSprite = new PIXI.TilingSprite(
        texture,
        gridWidth,
        gridHeight,
    );
    tilingSprite.name = "background";
    tilingSprite.tileScale.x = 4;
    tilingSprite.tileScale.y = 4;

    return tilingSprite;
}

/* 
WHAT: Draw cursor
WHY: Sprite indicates current cursor position in grid
*/
export function drawCursor() {

    const cursorTexture = PIXI.Texture.from('./cursor7.png');
    const cursor = PIXI.Sprite.from(cursorTexture);

    return cursor;
}